import { fetchCSV } from "@request/client";
import { getQueryParams } from "@request/helpers";

export type OrderCSVRequest = {
  date_start_time: number;
  date_end_time: number;
  limit?: number;
  offset?: number;
  status?: string;
  type?: string;
  method?: string;
};

export const getOrderCSVApi = async (userId: string, data: OrderCSVRequest) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchCSV({
      url: `api/v1/orders-csv/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("getOrderCSVApi failed:", error);
    throw error;
  }
};
